var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYesNoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5888 0 0 3.56557 0 7.94822C0 12.3309 3.5888 15.8964 8 15.8964C12.4112 15.8964 16 12.3309 16 7.94822C16 3.56557 12.4112 0 8 0ZM8 14.4513C4.39079 14.4513 1.45455 11.534 1.45455 7.94822C1.45455 4.36242 4.39079 1.44513 8 1.44513C11.6092 1.44513 14.5455 4.36242 14.5455 7.94822C14.5455 11.534 11.6092 14.4513 8 14.4513Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.1374L6.88589 9.22485L5.00032 7.35143C4.71634 7.0693 4.25583 7.06925 3.97181 7.35139C3.68778 7.63357 3.68778 8.09105 3.97181 8.37324L6.37161 10.7576C6.508 10.8931 6.69297 10.9693 6.88584 10.9693C6.88589 10.9693 6.88584 10.9693 6.88589 10.9693C7.07876 10.9693 7.26373 10.8931 7.40012 10.7577L12.0285 6.1593C12.3126 5.87711 12.3126 5.41963 12.0285 5.13744C11.7445 4.85526 11.284 4.85521 11 5.1374Z",
    fill: "#717171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesNoIcon);
export default __webpack_public_path__ + "static/media/yes-no-icon.c1d5fc4a47af4c17fc194dbf01f62bd3.svg";
export { ForwardRef as ReactComponent };